import { render } from "./HeroiconsOutlineClock.vue?vue&type=template&id=66dba41f"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClock.vue"]])

export default __exports__